import { useMemo, useRef } from "react";
import withName from "../../hoc/withName";
import { Dialog } from "primereact/dialog";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import { Divider } from "primereact/divider";

const DialogComponentWrapper = ({ children, containerId, formikRef, dialogState, searchButton, inviteButton, setDialogState, t, hideButtons,closeButtonOnly=null, noClosable, nextButton,width, ...extraProps }) => {
    const dialogRef = useRef(null);
    const disabled = Boolean(dialogState.disabled);
    const saveButtonContent = inviteButton? t("users.invite"):searchButton ? t?.("forms.search") : (nextButton ? t?.("external.next") : t?.("forms.save"));

    const buttons = useMemo(() => [{
    // do not handle submits on enter (prevent double submit, as formik handles it also)
        click: ({ type }) => type !== "keydown" && formikRef && formikRef.current.submitForm(),
        buttonModel: { cssClass: "e-primary", content: saveButtonContent, isPrimary: true, disabled }
    }, {
        click: () => { setDialogState({ visible: false }); },
        buttonModel: { cssClass: "e-flat", content: t?.("forms.cancel"), disabled }
    }], [saveButtonContent, disabled]);

    const footerContent = (
        <div>
            {
                closeButtonOnly?
                    <>
                        <Divider />
                        <ButtonPrime label={t?.("forms.close")} onClick={() => { setDialogState({ visible: false });}} className="dialog-button dbtn-save" />
                    </>
                    :<>
                        <Divider />
                        <ButtonPrime label={saveButtonContent} onClick={({ type }) => type !== "keydown" && formikRef && formikRef.current.submitForm()} className="dialog-button dbtn-save" />
                        <ButtonPrime label={t?.("forms.cancel")} onClick={() => { setDialogState({ visible: false });}} className="dialog-button dbtn-cancel" />
                    </>
            }
        </div>
    );
    const extraButtons = (
        <div>
            <Divider />
            {extraProps?.buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );
    const buttonsProp = extraProps.buttons ? extraButtons:footerContent;
    return (<>
        {hideButtons ?
            (noClosable ?
                <Dialog
                    className='dialog-prime'
                    ref={dialogRef} header={dialogState.headerText} modal closable={false} closeOnEscape={false}
                    visible={dialogState.visible} style={{ width: width?width:"500px" }} baseZIndex={1040}
                    {...extraProps}
                >
                    {children}
                </Dialog>
                :
                <Dialog
                    className='dialog-prime'
                    ref={dialogRef} header={dialogState.headerText} modal
                    visible={dialogState.visible} style={{ width: width?width:"500px" }} baseZIndex={1040} onHide={() => setDialogState({ visible: false })}
                    {...extraProps}
                >
                    {children}
                </Dialog>
            )
            :
            <Dialog
                className='dialog-prime'
                ref={dialogRef} header={dialogState.headerText} modal footer={buttonsProp}
                visible={dialogState.visible} style={{ width: width?width:"500px" }} baseZIndex={1040} onHide={() => setDialogState({ visible: false })}
                {...extraProps}
            >
                {children}
            </Dialog>}
    </>);
};

export default withName(DialogComponentWrapper, "DialogWrapper");
